import { EntityRequestOvertime } from "../../entity/EntityRequestOvertime";

export class DtoRequestOvertimesPostRes extends EntityRequestOvertime {}
